module.exports = __webpack_public_path__ + "static/media/loadingEmailAnimGrey.722e36bd.gif";